<div
  class="fixed inset-y-0 z-[200] flex max-w-full flex-col border-slate-200 bg-white shadow-2xl transition-transform duration-200 ease-out"
  [class]="
    sideClasses() +
    ' ' +
    (entered() ? 'translate-x-0' : enterTranslate()) +
    (visible() ? '' : ' hidden')
  "
  [style.width]="width()"
  role="complementary"
  [attr.aria-labelledby]="title() ? titleId : null"
  (keydown.escape)="onCloseClick()"
>
  <!-- Manija para colapsar, pegada al borde izquierdo del panel — misma
       altura que el botón flotante que lo abre (acoplamiento a propósito,
       ver drawer.component.ts) -->
  <button
    type="button"
    (click)="onCloseClick()"
    aria-label="Colapsar panel"
    class="absolute -left-10 top-32 z-10 flex h-12 w-10 items-center justify-center bg-primary text-white shadow-lg transition-colors hover:bg-primary-hover"
    style="border-radius: 12px 0 0 12px;"
  >
    <i class="pi pi-angle-right text-lg" aria-hidden="true"></i>
  </button>

  <!-- Header -->
  <div
    class="flex shrink-0 items-center justify-between border-b border-slate-200 px-6 py-4"
  >
    <h2
      [id]="titleId"
      class="text-sm font-bold uppercase leading-none tracking-tight text-slate-800"
    >
      {{ title() }}
    </h2>
    <button
      type="button"
      (click)="onCloseClick()"
      aria-label="Cerrar"
      class="p-1.5 text-slate-400 outline-none transition-colors hover:text-primary hover:bg-slate-100 rounded-md"
    >
      <i class="pi pi-times text-lg" aria-hidden="true"></i>
    </button>
  </div>

  <!-- Body -->
  <div class="flex-1 overflow-y-auto px-6 py-5 custom-scrollbar">
    <ng-content></ng-content>
  </div>

  <!-- Footer -->
  <ng-content select="[drawerFooter]"></ng-content>
</div>
